import { useAppState } from "./useReduxState"
import { FetchState, hasValue } from "../Models/Client/FetchState"
import {
    AppStatus,
    getAppStatus,
    compareAppStatus
} from "../Models/Client/AppStatus"
import { selectVolatileAppStatus } from "../Helpers/Functions/Selectors/appStatus"
import { useAppInstance } from "./useAppInstance"
import { useAppTemplate } from "./useAppTemplate"
import { useMemo } from "react"
import { Result } from "../Models/Utility/Result"

export function useAppStatus(
    appID?: string
): FetchState<AppStatus | undefined> {
    const volatileAppStatus = useAppState(state =>
        appID === undefined ? undefined : selectVolatileAppStatus(state, appID)
    )
    const instanceFetch = useAppInstance(appID)
    const templateFetch = useAppTemplate(appID)
    const acceptedCalibrationJobs = useAppState(state =>
        appID === undefined
            ? false
            : state.client.browser.calibrationJobAcceptedInstanceIds.includes(
                  appID
              )
    )

    return useMemo(() => {
        if (!hasValue(instanceFetch)) {
            return instanceFetch
        }

        if (!hasValue(templateFetch)) {
            return templateFetch
        }

        const serverAppStatus = getAppStatus(
            instanceFetch.value,
            templateFetch.value,
            acceptedCalibrationJobs
        )

        return Result.ok(
            serverAppStatus === undefined
                ? volatileAppStatus
                : volatileAppStatus === undefined
                ? serverAppStatus
                : compareAppStatus(volatileAppStatus, serverAppStatus) > 0
                ? volatileAppStatus
                : serverAppStatus
        )
    }, [
        instanceFetch,
        templateFetch,
        acceptedCalibrationJobs,
        volatileAppStatus
    ])
}
